import { render } from "./PrPreLoaderFull.vue?vue&type=template&id=4b6d0009"
import script from "./PrPreLoaderFull.vue?vue&type=script&lang=js"
export * from "./PrPreLoaderFull.vue?vue&type=script&lang=js"

import "./PrPreLoaderFull.vue?vue&type=style&index=0&id=4b6d0009&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__